import { type ParentProps, onMount } from "solid-js";
import { config } from "~/config";
import { getDeeplink, updateDeeplinkRegistry } from "~/stores/deeplink";
import { DeeplinkContext } from "./context";

export function DeeplinkProvider(props: ParentProps) {
	let deeplinkContainer: HTMLDivElement | undefined;

	const routeToDeeplinkOrUrl = (e: MouseEvent | string) => {
		if (typeof e === "string") {
			const href = e.replace(`https://${config.deepLinkEndpoint}`, "");

			const deeplink = getDeeplink(href);

			if (deeplink) {
				const params: Record<string, string> = {};

				if (href !== deeplink.internal) {
					const externalParts = href.split("/").reverse();

					for (const [index, param] of deeplink.queryParams.entries()) {
						params[param] = externalParts[index];
					}
				}

				const url = new URL(`${window.location.protocol}//${window.location.host}${deeplink.path}`);

				for (const [key, value] of Object.entries(params)) {
					url.searchParams.set(key, value);
				}

				window.open(url.toString(), "_self");

				return;
			}

			window.open(e, "_blank");

			return;
		}

		if (!e.target) {
			return;
		}

		const target = e.target as HTMLElement;

		if (target.tagName === "A") {
			const element = target as HTMLAnchorElement;
			const href = element.href.replace(`https://${config.deepLinkEndpoint}`, "");

			const deeplink = getDeeplink(href);

			if (deeplink) {
				e.preventDefault();

				const params: Record<string, string> = {};

				if (href !== deeplink.internal) {
					const externalParts = href.split("/").reverse();

					for (const [index, param] of deeplink.queryParams.entries()) {
						params[param] = externalParts[index];
					}
				}

				const url = new URL(`${window.location.protocol}//${window.location.host}${deeplink.path}`);

				for (const [key, value] of Object.entries(params)) {
					url.searchParams.set(key, value);
				}

				window.open(url.toString(), "_self");
			}
		}
	};

	// Mount a global event listener to handle deeplinks
	onMount(async () => {
		if (!deeplinkContainer) {
			console.warn("Couldn't find deeplink container element. Deeplinks will not work.");
			return;
		}

		await updateDeeplinkRegistry();

		deeplinkContainer.addEventListener("click", routeToDeeplinkOrUrl);
	});

	return (
		<DeeplinkContext.Provider value={{ routeToDeeplinkOrUrl }}>
			<div ref={deeplinkContainer}>{props.children}</div>
		</DeeplinkContext.Provider>
	);
}
